module.exports = __webpack_public_path__ + "static/media/kiarash.6594772f.jpg";